export const serializeFunction = fn => (fn.name ? `function ${fn.name}()` : 'function()');
